export enum CustomizationOptions {
  logo = 'header-logo-image-url',
  logoUrl = 'header-logo-href',
  footer = 'footer-logo-image-url',
  footerUrl = 'footer-logo-href',
  newsMenu = 'news-menu-label',
  newsMenuUrl = 'news-href',
}
